export default __webpack_public_path__ + "static/media/emptyFolder.7e25576f.svg";